<template>
  <span class="formatted-amount" @click="copyAmount">{{ formattedAmount }}</span>
</template>
<script>
import { copyText } from '@/utils/common'
export default {
  props: {
    value: {
      type: Number | String,
      default: 0
    },
    // 保留小数位数
    precision: {
      type: Number,
      default: 2
    },
    // 金额单位
    unit: {
      type: String,
      default: ''
    },
    // 金额是否显示符号
    showSign: {
      type: Boolean,
      default: false
    },
    // 金额是否显示负号
    showNegativeSign: {
      type: Boolean,
      default: false
    },
    // 金额是否显示单位
    showUnit: {
      type: Boolean,
      default: true
    },
    // 金额是否显示千分位分隔符
    showThousandSeparator: {
      type: Boolean,
      default: true
    },
    copyable: {
      type: Boolean,
      default: false
    },
    prefix: {
      type: String,
      default: ''
    }
  },
  computed: {
    formattedAmount() {
      let amount = this.value;

      // 转换为数字类型
      if (typeof amount !== 'number') {
        amount = Number(amount);
      }

      // 处理NaN情况
      if (isNaN(amount)) {
        amount = 0;
      }

      // 格式化数字
      const formatted = amount.toFixed(this.precision);

      // 分离整数部分和小数部分
      const parts = formatted.split('.');
      let integerPart = parts[0];
      const decimalPart = parts[1] || '';

      // 添加千分位分隔符
      if (this.showThousandSeparator) {
        integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      // 处理符号
      let sign = '';
      if (amount > 0 && this.showSign) {
        sign = '+';
      } else if (amount < 0 && (this.showSign || this.showNegativeSign)) {
        sign = '-';
        // 移除整数部分的负号
        integerPart = integerPart.replace('-', '');
      }

      // 组合整数部分和小数部分
      let result = sign + integerPart;
      if (decimalPart) {
        result += '.' + decimalPart;
      }

      // 添加单位
      if (this.showUnit) {
        result += ' ' + this.unit;
      }

      // 添加前缀
      if (this.prefix) {
        result = this.prefix + result;
      }

      return result;
    }
  },
  methods: {
    copyAmount() {
      if (this.copyable) {
        copyText(this.value);
        this.$message({
          message: '复制成功',
          type: 'success'
        });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.formatted-amount {
  i.el-icon-copy-document {
    display: none;
  }
  &:hover {
    cursor: pointer;
    i.el-icon-copy-document {
      display: inline;
      color: #409eff;
    }
  }
}
</style>
